export default "__VITE_ASSET__CiX76W_6__"